import React, { useEffect } from 'react';
import './questioner.style.scss';
import Panel from './wsPanel/wsPanel.index';
import Profile from './profile/profile.index';
import Notification from './notification/notification.index';
import PublishDetail from './publishDetail/publishDetail.index';
import { RoutePath } from 'data';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { toast } from 'react-toastify';
import { loadUserData, offlineQuestionerSubmit } from 'ucheck/ucheck.scripts';
import useInterval from 'scripts/useInterval';
import { userData } from 'scripts/storage';

const UCheckQuestioner: React.FC<ConnectedProps<typeof connector>> = function (
    props: ConnectedProps<typeof connector>,
) {
    useEffect(() => {
        if (userData.get()) {
            loadUserData(true);
            offlineQuestionerSubmit(true);
        }
    }, []);

    function refresh() {
        return new Promise<boolean>((resolve) => {
            if (props.expire) {
                toast.error(
                    'کاربر محترم به منظور فعالسازی مجدد بروزرسانی فرم ها و فضای های کاری لطفا یک بار از حساب کاربری خود خارج و مجددا وارد شوید.',
                );
                resolve(false);
            } else loadUserData().then((res) => resolve(res));
        });
    }

    return (
        <div className="ucheck-base-page">
            <Switch>
                <Route path={RoutePath.dashboard.profile.index} component={Profile} />
                <Route path={RoutePath.dashboard.notification} component={Notification} />
                <Route path={RoutePath.dashboard.publishDetail(':publish', ':form')} component={PublishDetail} />
                <Route path={RoutePath.dashboard.index}>
                    <Panel onRefresh={() => refresh()} />
                </Route>
                <Route path="*">
                    <Redirect to={RoutePath.dashboard.index} />
                </Route>
            </Switch>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    expire: state.expired,
});

const connector = connect(mapStateToProps);
export default connector(UCheckQuestioner);
